module.exports = __webpack_public_path__ + "static/img/icn_cart_default.15095fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_cart_default.png
// module id = sdY3
// module chunks = 10